import UserToPlace from "./UserToPlace";

export default UserToPlace;
